<template lang="pug">
  v-menu(
    v-model="supportMenu"
    offset-y
    left
    content-class="support-buttons__content"
    :close-on-content-click="false"
  )
    template(v-slot:activator="{ on }")
      v-btn(
        icon
        v-on="on"
        class="support-button"
        @click="supportMenu = !supportMenu"
      )
        e-svg-icon question-box
    div(class="support-buttons")
      div(class="text-12px light mb-6") Підтримка (09:00 - 21:00)
      div(class="d-flex align-center justify-space-between mb-4")
        div
          div(class="text-12px light") Telegram
          div(class="text-14px dark") @Dubi_Doc_UA_bot
        v-btn(
          icon
          class="support-buttons__icon"
          @click="openLink('https://t.me/Dubi_Doc_UA_bot')"
        )
          v-img(
            :src="require('~/assets/sprite/svg/telegram.svg')"
            max-width="20"
          )
      div(class="d-flex align-center justify-space-between")
        div
          div(class="text-12px light") Email
          div(class="text-14px dark") dubidoc@checkbox.ua
        e-link(
          class="support-buttons__icon"
          href="mailto:dubidoc@checkbox.ua"
        )
          e-svg-icon sms
</template>

<script>
import ESvgIcon from '~/components/elements/icons/e-svg-icon'
import ELink from '~/components/elements/links/e-link'

export default {
  name: 'MSupportButtons',
  components: {
    ESvgIcon,
    ELink
  },
  data() {
    return {
      supportMenu: false
    }
  },
  methods: {
    openLink(url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.support-button {
  width: 40px !important;
  height: 40px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;

  @media (min-width: map-get($breakpoints, 'sm')) {
    width: 48px !important;
    height: 48px !important;
  }
}
.support-buttons {
  width: 288px;
  border-radius: 16px;
  background: #fff;
  padding: 16px;

  &__content {
    box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.08);
    z-index: map-get($zIndexes, 'menu') !important;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 42px !important;
    height: 42px !important;

    border-radius: 12px;
    background: rgba(0, 0, 0, 0.03);
  }
}
</style>
